import { z } from "zod";
import { uuidSchema } from "./common";

export const fileCategorySchema = z.enum([
  "PRESCRIPTION",
  "MEDICATION_PHOTO",
  "LAB_REPORT",
  "DISCHARGE_DOCUMENT",
  "PATIENT_ATTACHMENT",
  "GENERATED_REPORT",
]);

/** Allow-list enforced again server-side in apps/worker — never trust client-declared MIME type alone. */
export const ALLOWED_UPLOAD_MIME_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/webp",
] as const;

export const MAX_UPLOAD_SIZE_BYTES = 15 * 1024 * 1024; // 15 MB

export const requestUploadSchema = z.object({
  category: fileCategorySchema,
  fileName: z.string().trim().min(1).max(255),
  mimeType: z.enum(ALLOWED_UPLOAD_MIME_TYPES),
  sizeBytes: z.number().int().positive().max(MAX_UPLOAD_SIZE_BYTES),
  relatedMtmAssessmentId: uuidSchema.optional(),
  relatedAppointmentId: uuidSchema.optional(),
  description: z.string().trim().max(500).optional(),
});

export type RequestUploadInput = z.infer<typeof requestUploadSchema>;
